/* ---------------------------------------------------------------------------------------
* about:支持显示的设备
* author:马兆铿
* date:2018-8-16
* ---------------------------------------------------------------------------------------- */

//首页显示的设备列表
class ShowDevice {
  constructor() {
    this.irc = [30, 67] // 红外遥控
    this.switch = [10] // 开关
    this.remote = [5, 6, 32, 58, 70, 73, 74, 75, 76, 77, 78, 106, 126, 127] // 添加的虚拟红外遥控
    this.socket = [2, 29, 43]  // 全部 [2, 43, 29, 53];
    this.light = [0, 1, 19, 38, 102, 116]  // 全部 [0, 1, 18, 19, 26, 38, 82， 102, 116];
    this.curtainMoto = [4, 8, 9, 34, 35, 39, 42, 68, 69, 71, 72, 105, 106, 109, 111]
    this.hanger = [52]
    this.window = [37, 100, 110]
    this.air = [36]
    this.other = []
  }

  /*  根据设备号获取设备类型名字
  * @param {num}deviceType
  * */
  getDeviceTypeName(deviceType) {
    for (let key in this) {
      const item = this[key]
      if (item.find(subItem => subItem === deviceType)) {
        return key
      }
    }
    return ''
  }

  /**
   * 不显示设备的判断函数
   * @param deviceType
   * @param subDeviceType
   * @return {boolean}
   */
  checkIfNotShow(deviceType, subDeviceType) {
    //根据需求来制定
    //插座
    if (this.switch.find(num => num === deviceType)) {
      if (subDeviceType === 10) { // 排气扇
        return true
      }
    }
    return false
  }
}

export const showDevice = new ShowDevice()



// WEBPACK FOOTER //
// ./src/utils/device/deviceShow.js